module.exports = __webpack_public_path__ + "img/builder-post-stub.d75cf700.svg";